import script from "./UserPasswordSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPasswordSetting.vue?vue&type=script&setup=true&lang=js"

import "@/features/user/styles/operationArea/UserPasswordSetting.css?vue&type=style&index=0&id=5db22c56&scoped=true&lang=css&external"
import "@/features/user/styles/operationArea/OperationAreaTheme.css?vue&type=style&index=1&id=5db22c56&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5db22c56"]])

export default __exports__